import AppContainerFromCreditControl from '../../../credit-control/src/components/AppContainer';
import { useUserContext } from '../providers/UserContextProvider';

interface CreditControlWithUserContextProps {
  apiUrl: string;
}

/**
 * Wrapper component that bridges UserContextProvider with the credit-control AppContainer.
 * Passes the userContext tenants to CompanyProvider via the settings prop.
 */
export function CreditControlWithUserContext({
  apiUrl,
}: CreditControlWithUserContextProps): React.ReactElement {
  const { tenants, isLoading } = useUserContext();

  return (
    <AppContainerFromCreditControl
      settings={{
        apiUrl,
        host: 'app-prod',
        externalTenants: tenants,
        externalTenantsLoading: isLoading,
      }}
    />
  );
}
